export default __webpack_public_path__ + "empty-environment-md.97f9d144.svg";